import { createIcon as t } from "../createIcon.js";
const c = {
  name: "AnglesRightIcon",
  height: 512,
  width: 512,
  svgPath: "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z",
  yOffset: 0,
  xOffset: 0
}, e = t(c);
export {
  e as AnglesRightIcon,
  c as AnglesRightIconConfig,
  e as default
};
